module.exports = __webpack_public_path__ + "img/sirene-red.a96c536f.svg";